import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class Assembly extends Product {
  @belongsTo('assembly-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'assembly';
  label = 'Assembly';

  get featuresJson() {
    return {
      numberOfStations: this.features.numberOfStations,
      statisticalReporting: this.features.statisticalReporting,
    };
  }
}

export default Assembly;
